export enum MeetingStatus {
  INTERVIEWEE_READY = 'intervieweeReady', // 지원자의 대기실 입장
  INTERVIEWER_READY = 'interviewerReady', // 면접관의 대기실 입장
  ROOM_OPEN = 'roomOpen', // 평가자 면접 시작 버튼
  START = 'start', // 지원자의 룸 입장
  END = 'end',
}

export enum InterviewEnum {
  interviewer = 'interviewer',
  interviewee = 'interviewee',
}

export type InterviewType = keyof typeof InterviewEnum;
